module.exports = __webpack_public_path__ + "img/eye-closed.745d7cc7.svg";